import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import {streamStates} from '../../lib/config';

const StreamState = ({value, onChange, published}) => (
    <SelectField 
        value={value}
        onChange={(e, i, v) => onChange(v)}
    >
        {streamStates.map(({value, primaryText}, i) =>
            <MenuItem
                key={i}
                value={value}
                disabled={!published && value === 'published'}
                primaryText={primaryText}
            />)
        }
    </SelectField>
);

export default StreamState;


// WEBPACK FOOTER //
// src/components/streams/StreamStatus.js